import CalenderPage from "../../pages/dashboard/calender/CalenderPage";
export const CalenderRoutes = [
  {
    name: "Lịch Vạn Niên",
    path: "",
    element: <CalenderPage />,
  },
];
